import thumbnail1 from "@packages/assets/thumbnails/thumbnail1.webp";
import thumbnail2 from "@packages/assets/thumbnails/thumbnail2.webp";
import thumbnail3 from "@packages/assets/thumbnails/thumbnail3.webp";
import thumbnail4 from "@packages/assets/thumbnails/thumbnail4.webp";
import thumbnail5 from "@packages/assets/thumbnails/thumbnail5.webp";
import thumbnail6 from "@packages/assets/thumbnails/thumbnail6.webp";
import thumbnail7 from "@packages/assets/thumbnails/thumbnail7.webp";
import thumbnail8 from "@packages/assets/thumbnails/thumbnail8.webp";
import thumbnail9 from "@packages/assets/thumbnails/thumbnail9.webp";
import { Placement } from "react-joyride";

export const faqs = {
  en: [
    {
      id: 1,
      question: "How do I add a new class?",
      answer:
        "Navigate to the Classes section and click on 'Add New Class' button.",
    },
    {
      id: 2,
      question: "Can I edit an assignment after publishing?",
      answer:
        "Yes, you can edit assignments by going to the Assignments section and clicking on the 'Edit' button.",
    },
    {
      id: 3,
      question: "How do students access their assignments?",
      answer:
        "Students receive a unique link for each assignment via email or through their student dashboard.",
    },
  ],
  tr: [
    {
      id: 1,
      question: "Nasıl yeni bir sınıf eklerim?",
      answer: "Sınıflar bölümüne giderek 'Yeni Sınıf Ekle' butonuna tıklayın.",
    },
    {
      id: 2,
      question: "Bir çalışmayı yayınladıktan sonra düzenleyebilir miyim?",
      answer:
        "Evet, çalışmaları düzenlemek için Çalışmalar bölümüne gidin ve 'Düzenle' butonuna tıklayın.",
    },
    {
      id: 3,
      question: "Öğrenciler çalışmalarına nasıl erişirler?",
      answer:
        "Öğrenciler, her bir çalışma için benzersiz bir bağlantı alırlar, bu bağlantıyı e-posta yoluyla veya öğrenci panellerinden alabilirler.",
    },
  ],
};

export const tutorials = {
  tr: [
    {
      id: 1,
      title: "Öğretmenler İçin Madlen : Giriş",
      description:
        "Bu videoda okulunuz öğretmenlerinin Madlen'e nasıl giriş yapabileceklerini anlatıyoruz.",
      youtubeId: "iBhXXTXUIs8",
      thumbnail: thumbnail1,
    },
    {
      id: 2,
      title: "Öğretmenler İçin Madlen: Anasayfa",
      description:
        "Bu videoda Madlen öğretmen platformundaki anasayfada neler yapabileceğinizden bahsettik.",
      youtubeId: "svg7wcUmhlw",
      thumbnail: thumbnail2,
    },
    {
      id: 3,
      title: "Öğretmenler için Madlen: Çalışmaların Takibi",
      description:
        'Bu videoda platformdaki "Çalışmalar" kısmından hazırladığınız testlerin nasıl listelendiğini, hangi grafiklerle sonuçları takip edebileceğinizi anlatıyoruz.',
      youtubeId: "s_71SIRjkhE",
      thumbnail: thumbnail3,
    },
    {
      id: 4,
      title: "Öğretmenler İçin Madlen:  Yazı ile Çalışma Oluşturma",
      description:
        "Bu videoda yapay zeka ile tercihlerinize göre nasıl soru ve çalışmalar oluşturabileceğinizi gösteriyoruz.",
      youtubeId: "LfVjb7k7m6g",
      thumbnail: thumbnail4,
    },
    {
      id: 5,
      title:
        "Öğretmenler için Madlen: Soru Paneli Ve Öğrencilere Çalışma Atama",
      description:
        "Bu videoda Madlenin oluşturduğu çalışmaları nasıl kendinize göre düzenleyip kişiselleştirebildiğinizden ve öğrencilere bu çalışmaları nasıl atayabileceğinizden bahsediyoruz.",
      youtubeId: "tbEX4VMxByM",
      thumbnail: thumbnail5,
    },
    {
      id: 6,
      title: "Öğretmenler için Madlen: Geçmiş Çalışmalar ve Analizleri",
      description:
        "Bu videoda, oluşturduğunuz geçmiş çalışmaların analizlerine, kazanımlarına ve genel özetlerine nasıl ulaşabileceğinizi gösteriyoruz.",
      youtubeId: "-_Eroan1Y-M",
      thumbnail: thumbnail6,
    },
    {
      id: 7,
      title: "Öğretmenler için Madlen: Konu Seçimi ile Çalışma Oluşturma",
      description:
        "Bu videoda sadece konu seçimi yaparak nasıl kolayca çalışma oluşturabileceğinizi anlatıyoruz.",
      youtubeId: "YNYKSMJSL7s",
      thumbnail: thumbnail7,
    },
    {
      id: 8,
      title: "Öğretmenler için Madlen: Yüklenen İçeriğe Göre Çalışma Oluşturma",
      description:
        "Bu videoda Madlen'in kaynak olarak kullanmasını istediğiniz içeriği yükleyerek nasıl çalışma oluşturabileceğinizi açıklıyoruz.",
      youtubeId: "itcd49zreqw",
      thumbnail: thumbnail8,
    },
    {
      id: 9,
      title: "Öğretmenler için Madlen: Analiz",
      description:
        "Bu videoda Madlen'in kaynak olarak kullanmasını istediğiniz içeriği yükleyerek nasıl çalışma oluşturabileceğinizi açıklıyoruz.",
      youtubeId: "U_Qs4PBhC7s",
      thumbnail: thumbnail9,
    },
  ],
  en: [
    {
      id: 1,
      title: "For Teachers: Madlen - Introduction",
      description:
        "In this video, we explain how the teachers at your school can log into Madlen.",
      youtubeId: "iBhXXTXUIs8",
      thumbnail: thumbnail1,
    },
    {
      id: 2,
      title: "For Teachers: Madlen - Homepage",
      description:
        "In this video, we discuss what you can do on the homepage of the Madlen teacher platform.",
      youtubeId: "svg7wcUmhlw",
      thumbnail: thumbnail2,
    },
    {
      id: 3,
      title: "For Teachers: Madlen - Tracking Assignments",
      description:
        'In this video, we explain how the tests you have prepared are listed in the "Assignments" section of the platform and how you can track the results with various graphs.',
      youtubeId: "s_71SIRjkhE",
      thumbnail: thumbnail3,
    },
    {
      id: 4,
      title: "For Teachers: Madlen - Creating Assignments with Text",
      description:
        "In this video, we show how you can create questions and assignments according to your preferences using artificial intelligence.",
      youtubeId: "LfVjb7k7m6g",
      thumbnail: thumbnail4,
    },
    {
      id: 5,
      title:
        "For Teachers: Madlen - Question Panel and Assigning Work to Students",
      description:
        "In this video, we explain how to customize the assignments created by Madlen and assign them to students.",
      youtubeId: "tbEX4VMxByM",
      thumbnail: thumbnail5,
    },
    {
      id: 6,
      title: "For Teachers: Madlen - Past Assignments and Their Analysis",
      description:
        "In this video, we show how you can access the analysis, achievements, and general summaries of the past assignments you have created.",
      youtubeId: "-_Eroan1Y-M",
      thumbnail: thumbnail6,
    },
    {
      id: 7,
      title: "For Teachers: Madlen - Creating Assignments by Topic Selection",
      description:
        "In this video, we explain how you can easily create an assignment by just selecting a topic.",
      youtubeId: "YNYKSMJSL7s",
      thumbnail: thumbnail7,
    },
    {
      id: 8,
      title:
        "For Teachers: Madlen - Creating Assignments Based on Uploaded Content",
      description:
        "In this video, we explain how to create an assignment by uploading the content you want Madlen to use as a resource.",
      youtubeId: "itcd49zreqw",
      thumbnail: thumbnail8,
    },
    {
      id: 9,
      title: "For Teachers: Madlen - Analysis",
      description:
        "In this video, we explain how to create an assignment by uploading the content you want Madlen to use as a resource.",
      youtubeId: "U_Qs4PBhC7s",
      thumbnail: thumbnail9,
    },
  ],
};

export const onboardingSteps = (isEdlink: boolean) => [
  ...(isEdlink
    ? [
        {
          target: "body",
          content: "dashboard.onboarding.edlink",
          placement: "center" as Placement,
          disableBeacon: true,
        },
      ]
    : []),
  {
    target: "body",
    content: "dashboard.onboarding.welcome",
    placement: "center" as Placement,
    disableBeacon: true,
  },
  {
    target: ".quick-actions",
    content: "dashboard.onboarding.quickActions",
    placement: "bottom" as Placement,
  },
  {
    target: ".createAssignment",
    content: "dashboard.onboarding.createAssignment",
    placement: "bottom" as Placement,
  },
  {
    target: ".interactive-material",
    content: "dashboard.onboarding.interactiveMaterial",
    placement: "bottom" as Placement,
  },
  {
    target: ".essay-grader",
    content: "dashboard.onboarding.essayGrader",
    placement: "bottom" as Placement,
  },
  {
    target: ".misconceptions",
    content: "dashboard.onboarding.misconceptions",
    placement: "bottom" as Placement,
  },
  {
    target: "body",
    content: "dashboard.onboarding.finish",
    placement: "center" as Placement,
    disableBeacon: true,
  },
];
